module.exports = __webpack_public_path__ + "img/huiben.93df9449.png";